module.exports = __webpack_public_path__ + "img/stop_btn.642bc6a6.png";